<template>
    <div class="ServicesCrossroadCard">
        <nuxt-link
            class="group relative flex items-baseline gap-4 rounded-md border border-solid border-white/25 p-6 transition duration-500 ease-in-out hover:bg-white dark:hover:bg-surface-card sm:flex-col"
            :class="{
                'bg-primary-500': themeColoured && item.type === ServicesCrossroadIcons.SKILLS,
                'bg-secondary-800': themeColoured && item.type === ServicesCrossroadIcons.MENTORING,
                'bg-blue-800': themeColoured && item.type === ServicesCrossroadIcons.JOBS,
                'bg-blue-900': themeColoured && item.type === ServicesCrossroadIcons.VOLUNTEERING,
                'hover:shadow-md': themeColoured
            }"
            :title="item.titleTag"
            :to="item.to"
        >
            <div
                class="CardIcon size-12 bg-cover"
                :class="{
                    'bg-naskilujsa-invert group-hover:bg-naskilujsa': item.type === ServicesCrossroadIcons.SKILLS,
                    'bg-poradsa-invert group-hover:bg-poradsa': item.type === ServicesCrossroadIcons.MENTORING,
                    'bg-pracuj-invert group-hover:bg-pracuj': item.type === ServicesCrossroadIcons.JOBS,
                    'bg-pomahaj-invert group-hover:bg-pomahaj': item.type === ServicesCrossroadIcons.VOLUNTEERING,
                    'bg-staze-invert group-hover:bg-staze': item.type === ServicesCrossroadIcons.INTERNSHIP,
                    'bg-sebapoznavanie-invert group-hover:bg-sebapoznavanie':
                        item.type === ServicesCrossroadIcons.SELF_KNOWLEDGE
                }"
            ></div>
            <CHeading class="mb-0 text-lg lg:text-2xl" variant="3">
                <span class="text-white transition duration-500 ease-in-out group-hover:text-black dark:group-hover:text-white">{{
                    item.title
                }}</span>
            </CHeading>
        </nuxt-link>
    </div>
</template>

<script lang="ts">
export enum ServicesCrossroadIcons {
    SKILLS = 'skills',
    MENTORING = 'mentoring',
    JOBS = 'jobs',
    VOLUNTEERING = 'projects',
    INTERNSHIP = 'internship',
    SELF_KNOWLEDGE = 'selfknowledge'
}
</script>

<script setup lang="ts">
interface Props {
    item: {
        type: ServicesCrossroadIcons
        titleTag: string
        to: string
        title: string
    }
    themeColoured?: boolean
}

defineProps<Props>()
</script>

<style lang="postcss" scoped>
.CardIcon {
    transition: background-image 500ms ease-in-out;
}
</style>
